import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/6597381331?text=Hi%20Cherry%20Stone%2C%20I%27d%20like%20to%20enquire%20about"
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-[0_20px_40px_-15px_rgba(37,211,102,0.55)] hover:shadow-[0_25px_50px_-15px_rgba(37,211,102,0.7)] hover:-translate-y-0.5 transition-all"
      aria-label="WhatsApp Cherry Stone"
    >
      <MessageCircle size={18} />
      <span className="hidden sm:block text-sm font-medium">Chat with Cherry Stone</span>
    </a>
  );
};

export default WhatsAppButton;
